// extracted by mini-css-extract-plugin
export var cardHeader = "_h9-0";
export var reorderHandle = "_h9-3";
export var titleArea = "_h9-1";
export var titleAreaWithHandle = "_h9-2";